type LabelProps = {
  forField: string;
  label: string | React.ReactNode;
}

export const Label = ({ label, forField }: LabelProps) => {
  return (
    <label htmlFor={forField} className="font-semibold text-gray-600 text-sm">{label}</label>
  )
};
